import apiClient from '../../../api/client';
import type {
  CobroExcepcionResponse,
  ExcepcionStatsResponse,
  CreateExcepcionDto,
  UpdateExcepcionDto,
  QueryExcepcionesDto,
  Paginated,
} from '@aid/shared';

export type {
  CobroExcepcionResponse,
  ExcepcionStatsResponse,
  CreateExcepcionDto,
  UpdateExcepcionDto,
  QueryExcepcionesDto,
};

export async function getExcepciones(
  params: QueryExcepcionesDto,
): Promise<Paginated<CobroExcepcionResponse>> {
  const { data } = await apiClient.get<Paginated<CobroExcepcionResponse>>('/admin/excepciones', {
    params,
  });
  return data;
}

export async function getExcepcionesStats(
  params: Omit<QueryExcepcionesDto, 'offset' | 'limit'>,
): Promise<ExcepcionStatsResponse> {
  const { data } = await apiClient.get<ExcepcionStatsResponse>('/admin/excepciones/stats', {
    params,
  });
  return data;
}

export async function getExcepcion(id: number): Promise<CobroExcepcionResponse> {
  const { data } = await apiClient.get<CobroExcepcionResponse>(`/admin/excepciones/${id}`);
  return data;
}

export async function createExcepcion(dto: CreateExcepcionDto): Promise<CobroExcepcionResponse> {
  const { data } = await apiClient.post<CobroExcepcionResponse>('/admin/excepciones', dto);
  return data;
}

export async function updateExcepcion(
  id: number,
  dto: UpdateExcepcionDto,
): Promise<CobroExcepcionResponse> {
  const { data } = await apiClient.patch<CobroExcepcionResponse>(`/admin/excepciones/${id}`, dto);
  return data;
}

export async function deleteExcepcion(id: number): Promise<void> {
  await apiClient.delete(`/admin/excepciones/${id}`);
}
